import { render } from "./LanguageChangingButton.vue?vue&type=template&id=d775cf96&scoped=true"
import script from "./LanguageChangingButton.vue?vue&type=script&lang=js"
export * from "./LanguageChangingButton.vue?vue&type=script&lang=js"

import "./LanguageChangingButton.vue?vue&type=style&index=0&id=d775cf96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d775cf96"]])

export default __exports__